const defaultFilters = () => ({
  status_filter: null,
  drafter_id: null
})

export default {
  namespaced: true,
  state: () => ({
    viewFilter: 'requested',
    openStatusFilter: true,
    searchTerm: '',
    filters: defaultFilters(),
    sortBy: 'required_date',
    sortDesc: false
  }),
  mutations: {
    setViewFilter (state, value) {
      state.viewFilter = value
    },
    setOpenStatusFilter (state, value) {
      state.openStatusFilter = value
      state.filters.status_filter = null
    },
    setSearchTerm (state, value) {
      state.searchTerm = value
    },
    setFilter (state, { key, value }) {
      state.filters[key] = value
    },
    removeFilter (state, key) {
      state.filters[key] = null
    },
    resetFilters (state) {
      state.filters = defaultFilters()
    },
    setSortBy (state, value) {
      state.sortBy = value
    },
    setSortDesc (state, value) {
      state.sortDesc = value
    }
  }
}
